import { atom } from 'jotai';

import { Employee } from '@/__generated__/graphql';

export type CurrentUserState = Partial<Employee> & {
  loginStatus: 'loading' | 'authenticated' | 'unauthenticated';
  hasPrinciple: boolean;
};

const currentUserAtom = atom<CurrentUserState>({
  loginStatus: 'unauthenticated',
  hasPrinciple: false,
});

export default currentUserAtom;
